// extracted by mini-css-extract-plugin
module.exports = {"container":"headerContactMobile_container__hnIPj","menuIsOpen":"headerContactMobile_menuIsOpen__i3aGk","text":"headerContactMobile_text__2TIRH","phones":"headerContactMobile_phones__1m5sg","btn":"headerContactMobile_btn__2M3Vq"};
    if(module.hot) {
      // 1744789720690
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  